import React, { useRef, useEffect, useState } from "react";
import RecorderDialog from "./RecorderDialog";
import { ReactComponent as VideoIcon } from "assets/img/icons/video-camera-icon.svg";
import { ReactComponent as AttachmentIcon } from "assets/img/icons/attachment-icon.svg";
import { useGlobalContext } from "store/contexts/globalContext";
import { useToasts } from "react-toast-notifications";

export default ({
	onChange = () => { },
	attachmentIconColor = "#A1A2A9",
	VideoAttachmentIcon = VideoIcon,
	AttachIcon = AttachmentIcon,
	videocamIconColor = "#A1A2A9",
	attachmentClass = "mw-20 ms-2 me-3",
	videoText = null,
	videoTextClass = null,
	attachmentTextClass = null,
	attachmentIconStyle = {
		cursor: "pointer",
		fill: attachmentIconColor,
	},
	attachmentText = null,
	teamsClientVideo = false,
	videoClass = "mw-20",
	showRecorderIcon = true,
	labelAttachment,
	classAttatchment,
	setHideModal = null,
	videoSpanClass = "px-2",
	showSelectors = true,
	selectors = ["audio", "image", "video", "screen"],
	type = "video",
	accepted = null,
	allowDocuments = false,
}) => {
	const { teamsIosClient } = useGlobalContext();
	const attachmentInputRef = useRef(null);
	const [showRecorderDialog, setShowRecorderDialog] = useState(false);
	const [acceptedMimeTypes, setAcceptedMimeTypes] = useState([
		".png",
		".jpg",
		".jpeg",
		".mp4",
		".mp3",
		".webm",
	]);
	const [randomNumber] = useState(Math.round(Math.random() * 1000).toFixed());
	const { addToast } = useToasts();

	const onAttachmentSelected = (event) => {
		const file = event.nativeEvent.target.files[0];

		attachmentInputRef.current.value = null;

		if (!file) {
			return;
		}

		const fileNameParts = file.name.split('.');
		const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();
		const notAllowedExtensions = ["docx", "doc", "pdf", "ppt", "txt"];

		if (!allowDocuments && notAllowedExtensions.includes(fileExtension)) {
			return addToast("You are not allowed to attach the document", { appearance: "error" });
		}

		onChange(file);
	};


	useEffect(() => {
		if (!accepted) {
			setAcceptedMimeTypes([
				".png",
				".jpg",
				".jpeg",
				".mp4",
				".mp3",
				".webm",
			]);
			return;
		}

		setAcceptedMimeTypes(accepted);
	}, [accepted]);


	const recordedAttachmentReceived = (file) => {
		if (!file) {
			return;
		}

		onChange(file);
	};

	const handleRecordDailog = (val) => {
		setShowRecorderDialog(val);
		if (setHideModal) setHideModal(val);
	};

	return (
		<>
			{showRecorderIcon && !teamsIosClient && !teamsClientVideo && (
				<span className={videoSpanClass}>
					<span
						className={videoTextClass}
						onClick={() => handleRecordDailog(true)}
					>
						<VideoAttachmentIcon
							className={videoClass}
							style={{ fill: videocamIconColor, cursor: "pointer" }}
						/>
						{videoText}
					</span>
					{showRecorderDialog && (
						<RecorderDialog
							selectors={selectors}
							showRecorderDialog={showRecorderDialog}
							hide={() => handleRecordDailog(false)}
							onChange={recordedAttachmentReceived}
							showSelectors={showSelectors}
							type={type}
						/>
					)}
				</span>
			)}
			<span className={classAttatchment}>
				<label
					className={labelAttachment}
					htmlFor={`attachment-${randomNumber}`}
					style={{ color: "inherit" }}
				>
					<input
						className="attachmentFile"
						id={`attachment-${randomNumber}`}
						type="file"
						ref={attachmentInputRef}
						accept={acceptedMimeTypes.join(",")}
						onChange={onAttachmentSelected}
					/>
					<span className={attachmentTextClass}>
						<AttachIcon
							className={attachmentClass}
							style={attachmentIconStyle}
						/>
						<span className="pointer attachmentText">{attachmentText}</span>
					</span>
				</label>
			</span>
		</>
	);
};
